import type { DomainConfiguration } from '../ConfigurationMapper';
import type { RulesContext } from './context';

// Ported from useConfigurationLogic.jsx:
//   applyExpansionBusinessRules   (lines 214-248, isTransitioningToExpansion block)
//   applyBaseSystemBusinessRules  (lines 299-313, isTransitioningToBaseSystem block)
export function applySystemTypeTransition(
  prev: DomainConfiguration, next: DomainConfiguration, ctx: RulesContext,
): void {
  const loading = !!ctx.metaState.isLoadingConfig;
  const s = next.system;

  const toExpansion = !loading && prev.system.systemType !== 'Expansion' && s.systemType === 'Expansion';
  if (toExpansion) {
    s.director.veloCount = 0;
    s.hybrid.enabled = false;
    s.afa.enabled = false;
    s.compressionRatio = 1.0;
    s.hybrid.compressionRatio = 1.0;
    s.afa.compressionRatio = 1.0;
    if (!s.hybrid.enabled) { s.hybrid.nodeCount = 0; s.hybrid.minRawCapacity = 0; }
    if (!s.afa.enabled)    { s.afa.nodeCount = 0;    s.afa.minRawCapacity = 0; }
    next.metadata.notes = 'V5000 Expansion';
  }

  const toBase = !loading && prev.system.systemType === 'Expansion' && s.systemType !== 'Expansion';
  if (toBase && s.director.veloCount < 3) s.director.veloCount = 3;
}
